module.exports = __webpack_public_path__ + "c2h4static/img/icon-blackhead@2x.41b8f9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Result/imgs/icon-blackhead@2x.png
// module id = 26bb
// module chunks = 1